import React from "react";
import "./App.css";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import Funds from "./pages/funds/Funds";
import PortfolioCompanies from "./pages/portfolio_companies/PortfolioCompanies";
import PortfolioCompany from "./pages/portfolio_company/PortfolioCompany";
import Investments from "./pages/investments/Investments";
import Dashboard from "./pages/dashboard/Dashboard";
import {Routes, Route, Link} from "react-router-dom";
import NavBar from "./containers/navbar/NavBar";
import Footer from "./containers/footer/Footer";
import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { Provider } from 'react-redux';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './common/UserSlice';
import PrivateRoute from "./containers/private_route/PrivateRoute";


function App() {

  const store = configureStore({
    reducer: {
      user: userReducer,
    },
  });

  function handleGoogleAuthenticationCallbackResponse(response) {
    console.log("Encoded JWT ID token: " + response.credential);
    var userObject = jwt_decode(response.credential);
    console.log(userObject);
    const setUserAction = {
      type: 'user/setUser',
      payload: userObject,
    };
    store.dispatch(setUserAction);
    console.log(document.getElementById("signInDiv").hidden);
    document.getElementById("signInDiv").hidden = true;
    console.log(document.getElementById("signInDiv").hidden);
  }

  useEffect(() => {
    /* global google */
    google.accounts.id.initialize({
      client_id: "263323600814-h3u0s3n12t4hr9o82vlt2rurn7sphg6r.apps.googleusercontent.com",
      callback: handleGoogleAuthenticationCallbackResponse
    });

    google.accounts.id.renderButton(
      document.getElementById("signInDiv"),
      {theme: "outline", size: "medium"}
    ); 

    //google.accounts.id.prompt();

  },[]);

  

  return (
    <Provider store={store}>
      <div className="App">
        <NavBar />
        <Routes>
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route exact path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route exact path="/funds" element={<PrivateRoute><Funds /></PrivateRoute>} />
          <Route exact path="/portfolio-companies" element={<PrivateRoute><PortfolioCompanies /></PrivateRoute>} />
          <Route exact path="/investments" element={<PrivateRoute><Investments /></PrivateRoute>} />
          <Route exact path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route exact path="/portfolio-company/:portcoId" element={<PrivateRoute><PortfolioCompany /></PrivateRoute>} />
        </Routes>
        <Footer />
      </div>
      </Provider>
  );
}

export default App;
